// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__cfARQ","resendInfoText":"OnGoingPaymentBox_resendInfoText__1zM7B"};